import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { PatientRepository } from '../../../domain/contracts/repositories';
import { Patient } from '../../../domain/entities';
import db from '../../../setup/firebase/firebase';
import { FirebasePatient } from '../entities';
import { PatientMapper } from '../mappers/patient.mapper';

export class FirebasePatientRepository implements PatientRepository {
  private readonly COLLECTION_PATH = 'patients';

  async findOne(id: string): Promise<Patient> {
    const docRef = doc(db, this.COLLECTION_PATH, id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data() as FirebasePatient;
    return PatientMapper.toDomain(data);
  }

  async findOneBySSN(ssn: string): Promise<Patient> {
    const q = query(collection(db, this.COLLECTION_PATH), where('ssn', '==', ssn));
    const querySnapshot = await getDocs(q);
    const patient = querySnapshot.docs[0].data() as FirebasePatient;
    patient.id = querySnapshot.docs[0].id;
    return PatientMapper.toDomain(patient);
  }

  async findWithPagination(): Promise<Patient[]> {
    const q = query(collection(db, this.COLLECTION_PATH));
    const querySnapshot = await getDocs(q);
    const patients = querySnapshot.docs.map((doc) => {
      const patient = doc.data() as FirebasePatient;
      patient.id = doc.id;
      return PatientMapper.toDomain(patient);
    });
    return patients;
  }

  async create(patient: Patient): Promise<Patient> {
    const firebasePatient = PatientMapper.toFirebaseDomain(patient);
    const docRef = await addDoc(collection(db, this.COLLECTION_PATH), firebasePatient);
    const docSnap = await getDoc(docRef);
    const newPatient = docSnap.data() as FirebasePatient;
    newPatient.id = docSnap.id;
    return PatientMapper.toDomain(newPatient);
  }

  async update(patient: Patient): Promise<Patient> {
    const firebasePatient = PatientMapper.toFirebaseDomain(patient);
    await setDoc(doc(db, this.COLLECTION_PATH, patient.id!), firebasePatient, { merge: true });
    return patient;
  }
}
